import { IActivityConfiguration } from 'app/authoring/interfaces/IActivityComponent';
import { Metamodel } from 'app/model/base/model';
import { ActivityConfigurations } from 'app/authoring/registries/activity-configurations';

import { ValidationActivity } from 'app/model/pipeline/validation.activity';
import { getActivityUrl } from 'app/shared/utils/links.util';

@ActivityConfigurations.register({})
export class ValidationActivityConfiguration implements IActivityConfiguration {
    public label = stringResources.ValidationActivityLabel;
    public name = 'Validation';
    public activityType = Metamodel.modelFor(ValidationActivity);
    public iconClass = 'svg-i_validation_16x16';
    public iconTransform = '';
    public categories = [stringResources.General];
    public supportedInTrident = true;
    public docLink = getActivityUrl('validation');
}
